/**
    This file is auto-generated by Reactor, do not modify
    @reactor-ignore
*/
import type { LocaleKey } from "../../../packages/localization/Locale"
import type { NonNegativeInteger } from "../../../reactor/Types/Primitives/NonNegativeNumber"
import type { PhoneNumber } from "../../../reactor/Types/Primitives/PhoneNumber"
import type { Email } from "../../../reactor/Types/Primitives/Email"
import type { Phone } from "../model/Phone"
import type { Image } from "../../../reactor/Types/File"
import type { Markdown } from "../../../reactor/Types/Primitives/Markdown"
import type { Localized } from "../../../packages/localization/Localized"
import type { Timestamp } from "../../../reactor/Types/Primitives/DateTime"
import type { Url } from "../../../reactor/Types/Primitives/Url"
import { SSRHook } from "../../../packages/ssr/SSRHook"
import type { Uuid } from "../../../reactor/Types/Primitives/Uuid"
import { server } from "../../../server"
type Headers = { [name: string]: string }
type CallOptions = {
    /**
     * The maximum number of times to retry the operation before giving up.
     *
     *  Defaults to 1 (one attempt in addition to the initial attempt).
     *
     *  The operation will only be retried if a handler plugin understood the
     *  error, was able to correct for it, and returned `{ retry: true }`.
     *
     *  The typical use case for this is to retry a request that failed
     *  due to e.g. an expired access token, that was successfully refreshed by a handler.
     *
     *  Other types of handler plugins may also be installed to deal with
     *  other types of errors which supports retrying.
     */
    maxRetries?: number

    /**
     * Override the default baseUrl for this request.
     */
    baseUrl?: string
}
export const defaults: {
    baseUrl: string
    fetch: typeof fetch
    headers: Headers
} = {
    baseUrl: server(),
    fetch(input: any, init: any) {
        // fetch() really wants to be called like this, treating it as a
        // value won't work
        return fetch(input, init)
    },
    headers: {
        "Content-Type": "application/json",
    },
}
export type File<mimeType = any> = string
// Creates an adapter so browser and node streams can be used interchangeably
async function* readStream(stream: any) {
    const reader = stream.getReader()
    while (true) {
        const { done, value } = await reader.read()
        if (done) break
        yield value
    }
}
/** Registers a link in the email system and returns a URL that can be used to
access the link with tracking. */
SSRHook.clientEndpoints.push({ name: "getEmailLinkRegister", func: getEmailLinkRegister })
export async function getEmailLinkRegister(
    link?: Url,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<undefined | string | Url> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (link !== undefined) queryArgs.push("link=" + encodeURIComponent(link.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/email/link-register${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useEmailLinkRegister = SSRHook<
    [link: Url | null | undefined],
    undefined | string | Url
>("getEmailLinkRegister", undefined, undefined, getEmailLinkRegister, ["link"], undefined)
export type GetAnalyticsCachePerformanceStatsDto = {
    name: string
    size: number
    maxSize: number
    cacheHits: number
    cacheMisses: number
    rehashes: Timestamp[]
}
SSRHook.clientEndpoints.push({
    name: "getAnalyticsCachePerformanceStats",
    func: getAnalyticsCachePerformanceStats,
})
export async function getAnalyticsCachePerformanceStats(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetAnalyticsCachePerformanceStatsDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/analytics-cache-monitor/stats`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useAnalyticsCachePerformanceStats = SSRHook<
    [],
    GetAnalyticsCachePerformanceStatsDto[]
>(
    "getAnalyticsCachePerformanceStats",
    undefined,
    undefined,
    getAnalyticsCachePerformanceStats,
    [],
    undefined
)
export type CountryCode =
    | "CI"
    | "ID"
    | "AF"
    | "AX"
    | "AL"
    | "DZ"
    | "AS"
    | "AD"
    | "AO"
    | "AI"
    | "AQ"
    | "AG"
    | "AR"
    | "AM"
    | "AW"
    | "AU"
    | "AT"
    | "AZ"
    | "BS"
    | "BH"
    | "BD"
    | "BB"
    | "BY"
    | "BE"
    | "BZ"
    | "BJ"
    | "BM"
    | "BT"
    | "BO"
    | "BQ"
    | "BA"
    | "BW"
    | "BV"
    | "BR"
    | "IO"
    | "BN"
    | "BG"
    | "BF"
    | "BI"
    | "KH"
    | "CM"
    | "CA"
    | "CV"
    | "KY"
    | "CF"
    | "TD"
    | "CL"
    | "CN"
    | "CX"
    | "CC"
    | "CO"
    | "KM"
    | "CG"
    | "CD"
    | "CK"
    | "CR"
    | "HR"
    | "CU"
    | "CW"
    | "CY"
    | "CZ"
    | "DK"
    | "DJ"
    | "DM"
    | "DO"
    | "EC"
    | "EG"
    | "SV"
    | "GQ"
    | "ER"
    | "EE"
    | "ET"
    | "FK"
    | "FO"
    | "FJ"
    | "FI"
    | "FR"
    | "GF"
    | "PF"
    | "TF"
    | "GA"
    | "GM"
    | "GE"
    | "DE"
    | "GH"
    | "GI"
    | "GR"
    | "GL"
    | "GD"
    | "GP"
    | "GU"
    | "GT"
    | "GG"
    | "GN"
    | "GW"
    | "GY"
    | "HT"
    | "HM"
    | "VA"
    | "HN"
    | "HK"
    | "HU"
    | "IS"
    | "IN"
    | "IR"
    | "IQ"
    | "IE"
    | "IM"
    | "IL"
    | "IT"
    | "JM"
    | "JP"
    | "JE"
    | "JO"
    | "KZ"
    | "KE"
    | "KI"
    | "KP"
    | "KR"
    | "KW"
    | "KG"
    | "LA"
    | "LV"
    | "LB"
    | "LS"
    | "LR"
    | "LY"
    | "LI"
    | "LT"
    | "LU"
    | "MO"
    | "MK"
    | "MG"
    | "MW"
    | "MY"
    | "MV"
    | "ML"
    | "MT"
    | "MH"
    | "MQ"
    | "MR"
    | "MU"
    | "YT"
    | "MX"
    | "FM"
    | "MD"
    | "MC"
    | "MN"
    | "ME"
    | "MS"
    | "MA"
    | "MZ"
    | "MM"
    | "NA"
    | "NR"
    | "NP"
    | "NL"
    | "NC"
    | "NZ"
    | "NI"
    | "NE"
    | "NG"
    | "NU"
    | "NF"
    | "MP"
    | "NO"
    | "OM"
    | "PK"
    | "PW"
    | "PS"
    | "PA"
    | "PG"
    | "PY"
    | "PE"
    | "PH"
    | "PN"
    | "PL"
    | "PT"
    | "PR"
    | "QA"
    | "RE"
    | "RO"
    | "RU"
    | "RW"
    | "BL"
    | "SH"
    | "KN"
    | "LC"
    | "MF"
    | "PM"
    | "VC"
    | "WS"
    | "SM"
    | "ST"
    | "SA"
    | "SN"
    | "RS"
    | "SC"
    | "SL"
    | "SG"
    | "SX"
    | "SK"
    | "SI"
    | "SB"
    | "SO"
    | "ZA"
    | "GS"
    | "SS"
    | "ES"
    | "LK"
    | "SD"
    | "SR"
    | "SJ"
    | "SZ"
    | "SE"
    | "CH"
    | "SY"
    | "TW"
    | "TJ"
    | "TZ"
    | "TH"
    | "TL"
    | "TG"
    | "TK"
    | "TO"
    | "TT"
    | "TN"
    | "TR"
    | "TM"
    | "TC"
    | "TV"
    | "UG"
    | "UA"
    | "AE"
    | "GB"
    | "US"
    | "UM"
    | "UY"
    | "UZ"
    | "VU"
    | "VE"
    | "VN"
    | "VG"
    | "VI"
    | "WF"
    | "EH"
    | "YE"
    | "ZM"
    | "ZW"
/** Integer currency amount in major units.

E.g. 3.50 USD would be represented as the number `3.50`.

This type is used for convenience, and should not be used for calculations.
Use `CurrencyMinorUnits`, or the `CurrencyAmount` type for that. */
export type CurrencyMajorUnits = number
/** A date string of the form `YYYY-MM-DD`, representing a date in the local
time zone. */
export type LocalDate = string
/** A time string of the form `HH:mm` (24-hour), representing a time of day in
the local time zone. */
export type LocalTime = string
export type GetShippingOptionsOptions0ManualShippingOptionSlotsDto = {
    id: Uuid<"ManualShippingSlot">
    date: LocalDate
    from: LocalTime
    to: LocalTime
    full: boolean
}
export type ManualShippingOption = {
    type: "Manual"
    name: Localized<string>
    description: Localized<string>
    cost: CurrencyMajorUnits
    slots: GetShippingOptionsOptions0ManualShippingOptionSlotsDto[]
}
/** Represents a currency amount. The amount is stored as an integer amount of
minor units (e.g. cents, pence, etc.). The currency code is a three-letter
ISO 4217 code.

In addition, the currency amount converted to major units is provided for
convenience. This is the same value as the `amountMinorUnits`, and does not
take into account any rounding or formatting rules. Due to JavaScript's
handling of floating point numbers, the result may not be exactly what you
expect. */
/** Integer currency amount in minor units.

The input value will be rounded to the nearest integer using the provided
rounding function. The default is Math.round.

E.g. 3.50 USD would be represented as 350. */
export type CurrencyMinorUnits = number
export type CurrencyCode =
    | "AFA"
    | "ALL"
    | "DZD"
    | "AOA"
    | "ARS"
    | "AMD"
    | "AWG"
    | "AUD"
    | "AZN"
    | "BSD"
    | "BHD"
    | "BDT"
    | "BBD"
    | "BYR"
    | "BEF"
    | "BZD"
    | "BMD"
    | "BTN"
    | "BTC"
    | "BOB"
    | "BAM"
    | "BWP"
    | "BRL"
    | "GBP"
    | "BND"
    | "BGN"
    | "BIF"
    | "KHR"
    | "CAD"
    | "CVE"
    | "KYD"
    | "XOF"
    | "XAF"
    | "XPF"
    | "CLP"
    | "CNY"
    | "COP"
    | "KMF"
    | "CDF"
    | "CRC"
    | "HRK"
    | "CUC"
    | "CZK"
    | "DKK"
    | "DJF"
    | "DOP"
    | "XCD"
    | "EGP"
    | "ERN"
    | "EEK"
    | "ETB"
    | "EUR"
    | "FKP"
    | "FJD"
    | "GMD"
    | "GEL"
    | "DEM"
    | "GHS"
    | "GIP"
    | "GRD"
    | "GTQ"
    | "GNF"
    | "GYD"
    | "HTG"
    | "HNL"
    | "HKD"
    | "HUF"
    | "ISK"
    | "INR"
    | "IDR"
    | "IRR"
    | "IQD"
    | "ILS"
    | "ITL"
    | "JMD"
    | "JPY"
    | "JOD"
    | "KZT"
    | "KES"
    | "KWD"
    | "KGS"
    | "LAK"
    | "LVL"
    | "LBP"
    | "LSL"
    | "LRD"
    | "LYD"
    | "LTL"
    | "MOP"
    | "MKD"
    | "MGA"
    | "MWK"
    | "MYR"
    | "MVR"
    | "MRO"
    | "MUR"
    | "MXN"
    | "MDL"
    | "MNT"
    | "MAD"
    | "MZM"
    | "MMK"
    | "NAD"
    | "NPR"
    | "ANG"
    | "TWD"
    | "NZD"
    | "NIO"
    | "NGN"
    | "KPW"
    | "NOK"
    | "OMR"
    | "PKR"
    | "PAB"
    | "PGK"
    | "PYG"
    | "PEN"
    | "PHP"
    | "PLN"
    | "QAR"
    | "RON"
    | "RUB"
    | "RWF"
    | "SVC"
    | "WST"
    | "SAR"
    | "RSD"
    | "SCR"
    | "SLL"
    | "SGD"
    | "SKK"
    | "SBD"
    | "SOS"
    | "ZAR"
    | "KRW"
    | "XDR"
    | "LKR"
    | "SHP"
    | "SDG"
    | "SRD"
    | "SZL"
    | "SEK"
    | "CHF"
    | "SYP"
    | "STD"
    | "TJS"
    | "TZS"
    | "THB"
    | "TOP"
    | "TTD"
    | "TND"
    | "TRY"
    | "TMT"
    | "UGX"
    | "UAH"
    | "AED"
    | "UYU"
    | "USD"
    | "UZS"
    | "VUV"
    | "VEF"
    | "VND"
    | "YER"
    | "ZMK"
export type CurrencyAmount = {
    /** The full amount in minor units (e.g. cents, pence, etc.)

E.g. `3.50` USD would be represented as the integer `350`.*/
    minorUnits: CurrencyMinorUnits
    /** The full amount in major units (e.g. dollars, euros, etc.), provided for
convenience. In case of discrepancies due to floating-point inaccuracy,
the `amountMinorUnits` field should be considered the source of truth.

This semantically the same value as the `amountMinorUnits`, and does not
take into account any rounding or formatting rules. Due to JavaScript's
handling of floating point numbers, the result may not be exactly what
you expect.*/
    majorUnits: CurrencyMajorUnits
    /** The currency code.*/
    currency: CurrencyCode
}
export type GetShippingOptionsOptions01Dto = { price: CurrencyAmount }
export type GetShippingOptionsOptions0Dto = ManualShippingOption & GetShippingOptionsOptions01Dto
export type PostalShippingShippingOption = {
    type: "PostalShipping"
    name: Localized<string>
    description: Localized<string>
    cost: CurrencyMajorUnits
}
export type GetShippingOptionsOptions1Dto = PostalShippingShippingOption &
    GetShippingOptionsOptions01Dto
export type GetShippingOptionsDto = {
    options: (GetShippingOptionsOptions0Dto | GetShippingOptionsOptions1Dto)[]
}
SSRHook.clientEndpoints.push({ name: "getShippingOptions", func: getShippingOptions })
export async function getShippingOptions(
    countryCode: CountryCode,
    zipCode: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetShippingOptionsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (countryCode !== undefined)
            queryArgs.push("countryCode=" + encodeURIComponent(countryCode.valueOf()))
        if (zipCode !== undefined)
            queryArgs.push("zipCode=" + encodeURIComponent(zipCode.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/shipping-options${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useShippingOptions = SSRHook<
    [countryCode: CountryCode | null, zipCode: string | null],
    GetShippingOptionsDto
>(
    "getShippingOptions",
    "GetShippingOptionsDto",
    undefined,
    getShippingOptions,
    ["countryCode", "zipCode"],
    undefined
)
export type IconName =
    | "warning"
    | "filter"
    | "at"
    | "star"
    | "data"
    | "close"
    | "placeholder"
    | "menu"
    | "trustpilot"
    | "asterisk"
    | "arrowUp"
    | "arrowRight"
    | "arrowDown"
    | "arrowLeft"
    | "calendar"
    | "calendarFilled"
    | "check"
    | "checkBadge"
    | "checkBadgeFilled"
    | "checkSquareOffset"
    | "chevronUp"
    | "chevronRight"
    | "chevronDown"
    | "chevronLeft"
    | "creditCard"
    | "dataFilled"
    | "desktop"
    | "device"
    | "deviceFilled"
    | "delivery"
    | "deliveryFilled"
    | "eraser"
    | "globe"
    | "globeFilled"
    | "handCoins"
    | "more"
    | "navigationArrow"
    | "plus"
    | "piggybank"
    | "pin"
    | "receipt"
    | "shield"
    | "shuffle"
    | "simCard"
    | "starFilled"
    | "tablet"
    | "truck"
    | "vipps"
    | "watch"
    | "wave"
export type GetRenewalOptionsInsuranceInsuranceSellingPointsDto = {
    id: Uuid<"Uuid">
    text: Localized<string>
    /** Override the icon that should be used when presenting this selling point in an
icon list.*/
    icon?: IconName
}
export type Insurance = {
    id: Uuid<"Insurance">
    displayName: Localized<string>
    description: Localized<string>
    sellingPoints: GetRenewalOptionsInsuranceInsuranceSellingPointsDto[]
}
export type PhoneMonthlyCost = {
    phone: CurrencyAmount
    insurance?: CurrencyAmount
    /** Total for all items. Discounts are not applied as they can vary per month.*/
    itemsTotal: CurrencyAmount
}
export type GetRenewalOptionsOptionsDto = { months: number; price: PhoneMonthlyCost }
export type GetRenewalOptionsDto = {
    renewalDate: undefined | Timestamp
    insurance: undefined | Insurance
    options: GetRenewalOptionsOptionsDto[]
}
SSRHook.clientEndpoints.push({ name: "getRenewalOptions", func: getRenewalOptions })
export async function getRenewalOptions(
    id: Uuid<"PhoneOrder">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetRenewalOptionsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-orders/${id}/renewal-options`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type BadRequest = {
    /** The type of this error, can be used for union discrimination*/ type: "BadRequest"
    status: number
    detail: string
    stack?: string
}
export type Forbidden = {
    /** The type of this error, can be used for union discrimination*/ type: "Forbidden"
    status: number
    detail: string
    stack?: string
}
export type UnauthorizedWithVipps = {
    /** The type of this error, can be used for union discrimination*/ type: "UnauthorizedWithVipps"
    status: number
    detail: string
    stack?: string
}
export type GetRenewalOptionsError = BadRequest | Forbidden | UnauthorizedWithVipps
export function IsGetRenewalOptionsError(e: any): e is GetRenewalOptionsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "UnauthorizedWithVipps")
    )
}
export const useRenewalOptions = SSRHook<[id: Uuid<"PhoneOrder"> | null], GetRenewalOptionsDto>(
    "getRenewalOptions",
    "GetRenewalOptionsDto",
    undefined,
    getRenewalOptions,
    ["id"],
    undefined
)
/** Renews a phone order with the given number of months.

The months must be one of the renewal options available for the phone model,
returned by `getRenewalOptions`. */
SSRHook.clientEndpoints.push({ name: "postRenewal", func: postRenewal })
export async function postRenewal(
    id: Uuid<"PhoneOrder">,
    months: number,
    tnc: Uuid<"TermsAndConditions">,
    tncInsurance: Uuid<"TermsAndConditions">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (months !== undefined) queryArgs.push("months=" + encodeURIComponent(months.valueOf()))
        if (tnc !== undefined) queryArgs.push("tnc=" + encodeURIComponent(tnc.valueOf()))
        if (tncInsurance !== undefined)
            queryArgs.push("tncInsurance=" + encodeURIComponent(tncInsurance.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/phone-orders/${id}/renewal${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostRenewalError = BadRequest | Forbidden | UnauthorizedWithVipps
export function IsPostRenewalError(e: any): e is PostRenewalError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Forbidden" || e.type === "UnauthorizedWithVipps")
    )
}
export type OrderNumber = string
export type PhoneOrderStatus =
    | "returning"
    | "expired"
    | "new"
    | "shipped"
    | "delivered"
    | "returned"
    | "reserved"
export type GetPhoneOrdersOrdersModelFeatures1Dto = { id: Uuid<"Feature">; text: Localized<string> }
export type GetPhoneOrdersOrdersModelDto = {
    id: Uuid<"PhoneModel">
    name: Localized<string>
    /** Features for this phone to be promoted in the product cards and on the product page.*/
    features: undefined | GetPhoneOrdersOrdersModelFeatures1Dto[]
    /** A more detailed description of the phone model.*/
    description: undefined | Localized<Markdown>
}
export type GetPhoneOrdersOrdersPhoneDto = {
    id: Uuid<"Phone">
    color: string
    storage: string
    images: undefined | Image[]
}
/** A string that holds TypeScript source code that can be executed in a certain environment.

 Use the `@declarations` attribute to point to a function that can emit declarations
 to populate intellisense with legal symbols. */
export type TypeScript = string
export type PhoneOrderDiscount = {
    /** Name of the discount, to use in receipt and other relevant places.*/ name: Localized<string>
    /** Start month of the discount in the subscription period. First month is 1. It is important
that discounts are not added (or changed) for a month that has already been charged.*/
    startMonth: number
    /** For how many months should the discount be applied.*/
    months: number
    /** Expression that should return the monthly discount based on the phone monthly price,
available as `{{phoneMonthlyPrice}}`.*/
    formula: TypeScript
}
export type PhoneOrderRentalPeriod = {
    months: number
    monthlyPrice: PhoneMonthlyCost
    discounts?: PhoneOrderDiscount[]
}
export type ManualShipping = { type: "Manual"; slot: Uuid<"ManualShippingSlot"> }
export type PostalShippingShipping = { type: "PostalShipping"; delivery: "standard" }
export type Shipping = ManualShipping | PostalShippingShipping
export type TradeInDiscount = {
    /** Name of the discount, to use in receipt and other relevant places.*/ name: Localized<string>
    /** The period index the trade in discount starts.*/
    startPeriodIndex: number
    /** For how many months should the discount be applied.*/
    months: number
    /** The monthly discount amount.*/
    amount: CurrencyAmount
}
export type PhoneOrderTradeIn = {
    form: Uuid<"TradeInDeviceForm">
    version: number
    responses: Uuid<"TradeInResponse">[]
    discount: TradeInDiscount
}
export type GetPhoneOrdersOrdersDto = {
    id: Uuid<"PhoneOrder">
    orderNumber: OrderNumber
    nextChargeDate: any
    /** The status of the order.*/
    status: PhoneOrderStatus
    /** Custom status to show to the customer, that should override the status in the system.*/
    customStatus: undefined | Localized<string>
    /** Whether this order has been cancelled. This will stop the subscription
charges. Cannot be undone.*/
    cancelled: undefined | boolean
    cancellationRequested: boolean
    model: GetPhoneOrdersOrdersModelDto
    /** When the order was placed.*/
    placed: Timestamp
    phone: GetPhoneOrdersOrdersPhoneDto
    /** If a subscription is renewed, a new rental period is created and the current period is cut
short.*/
    rentalPeriods: PhoneOrderRentalPeriod[]
    shipping: Shipping
    tradeIn: undefined | PhoneOrderTradeIn
}
export type GetPhoneOrdersDto = { orders: GetPhoneOrdersOrdersDto[] }
SSRHook.clientEndpoints.push({ name: "getPhoneOrders", func: getPhoneOrders })
export async function getPhoneOrders(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPhoneOrdersDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-orders`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetPhoneOrdersError = UnauthorizedWithVipps
export function IsGetPhoneOrdersError(e: any): e is GetPhoneOrdersError {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps"
}
export const usePhoneOrders = SSRHook<[], GetPhoneOrdersDto>(
    "getPhoneOrders",
    "GetPhoneOrdersDto",
    undefined,
    getPhoneOrders,
    [],
    undefined
)
export type GetPhoneOrderNextChargeDiscounts1Dto = {
    /** Name of the discount, to use in receipt and other relevant places.*/ name: Localized<string>
    amount: CurrencyAmount
    /** For how many months should the discount be applied.*/
    totalMonths: number
    remainingMonths: number
}
export type GetPhoneOrderNextChargeDto = {
    date: undefined | string
    discounts: undefined | GetPhoneOrderNextChargeDiscounts1Dto[]
    total: CurrencyAmount
}
export type GetPhoneOrderReceiptsDto = {
    id: Uuid<"AdyenReceipt">
    date: Timestamp
    total: CurrencyAmount
}
export type CustomerNumber = string
export type Address = {
    street: string
    unit?: string
    city: string
    zip: string
    country: CountryCode
}
export type GetPhoneOrderUserLastCreditCheckDto = { timestamp: Timestamp; success: boolean }
export type User = {
    id: Uuid<"User">
    /** The `sub` from the Vipps user info API.*/
    sub: string
    customerNumber: CustomerNumber
    givenName?: string
    familyName?: string
    email?: Email
    phoneNumber?: PhoneNumber
    address?: Address
    lastCreditCheck?: GetPhoneOrderUserLastCreditCheckDto
    /** Limit how many orders this user is allowed to make.*/
    orderLimit?: NonNegativeInteger
    /** Date when the user consented to marketing.*/
    marketingConsent?: Timestamp
    /** Preferred stored payment method id.*/
    preferredStoredPaymentMethodId?: string
}
/** A date string of the form `YYYY-MM-DDTHH:mm`, representing a date in a local
time zone understood from the context. */
export type LocalDateTime = string
export type ManualShippingSlot = {
    id: Uuid<"ManualShippingSlot">
    /** The start date of the shipping slot.*/
    startDate: LocalDateTime
    /** The end date of the shipping slot.*/
    endDate: LocalDateTime
    /** The region where the shipping slot is available.*/
    region: Uuid<"Region">
    /** The maximum number of orders that can be placed in this shipping slot.*/
    maxOrders: number
}
export type GetPhoneOrderTradeIn1DiscountDto = {
    /** Name of the discount, to use in receipt and other relevant places.*/ name: Localized<string>
    /** The monthly discount amount.*/
    amount: CurrencyAmount
    /** For how many months should the discount be applied.*/
    totalMonths: number
    remainingMonths: number
}
export type GetPhoneOrderTradeIn1Dto = {
    discount: GetPhoneOrderTradeIn1DiscountDto
    form: Uuid<"TradeInDeviceForm">
    version: number
    responses: Uuid<"TradeInResponse">[]
}
export type GetPhoneOrderModelFeatures1Dto = { id: Uuid<"Feature">; text: Localized<string> }
export type GetPhoneOrderModelDto = {
    id: Uuid<"PhoneModel">
    name: Localized<string>
    /** Features for this phone to be promoted in the product cards and on the product page.*/
    features: undefined | GetPhoneOrderModelFeatures1Dto[]
    /** A more detailed description of the phone model.*/
    description: undefined | Localized<Markdown>
}
export type GetPhoneOrderDto = {
    monthsIntoPeriod: number
    monthsLeft: number
    rentalPeriod: PhoneOrderRentalPeriod
    nextCharge: GetPhoneOrderNextChargeDto
    phone: Phone
    insurance: undefined | Uuid<"Insurance">
    receipts: GetPhoneOrderReceiptsDto[]
    user: User
    colorDisplayName: Localized<string>
    storageDisplayName: Localized<string>
    gradeDisplayName: undefined | Localized<string>
    invoiceDateOfMonth: undefined | number
    shippingSlot: undefined | ManualShippingSlot
    shippingAddress: Address
    shippingCost: CurrencyAmount
    tradeIn: undefined | GetPhoneOrderTradeIn1Dto
    id: Uuid<"PhoneOrder">
    orderNumber: OrderNumber
    nextChargeDate: any
    /** The status of the order.*/
    status: PhoneOrderStatus
    /** Custom status to show to the customer, that should override the status in the system.*/
    customStatus: undefined | Localized<string>
    /** Whether this order has been cancelled. This will stop the subscription
charges. Cannot be undone.*/
    cancelled: undefined | boolean
    cancellationRequested: boolean
    model: GetPhoneOrderModelDto
    /** When the order was placed.*/
    placed: Timestamp
    /** If a subscription is renewed, a new rental period is created and the current period is cut
short.*/
    rentalPeriods: PhoneOrderRentalPeriod[]
    shipping: Shipping
}
SSRHook.clientEndpoints.push({ name: "getPhoneOrder", func: getPhoneOrder })
export async function getPhoneOrder(
    id: Uuid<"PhoneOrder">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPhoneOrderDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-orders/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetPhoneOrderError = BadRequest
export function IsGetPhoneOrderError(e: any): e is GetPhoneOrderError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const usePhoneOrder = SSRHook<[id: Uuid<"PhoneOrder"> | null], GetPhoneOrderDto>(
    "getPhoneOrder",
    "GetPhoneOrderDto",
    undefined,
    getPhoneOrder,
    ["id"],
    undefined
)
/** An extended type for monthly cost for getting order price, which as opposed to a regular order
includes trade-in discount and discounted total. Once a subscription is running, the discounts
and monthly total may vary, but during checkout we are showing the assumed (and correct unless
other changes are made after order is placed) discounts and total. */
export type PhoneOrderPriceMonthlyCost = PhoneMonthlyCost & {
    tradeInDiscount?: CurrencyAmount
    /** Total monthly charge with trade-in discount applied.*/
    discountedTotal: CurrencyAmount
}
export type RelativePhysicalSize = number
export type PhoneOffer = Phone & {
    quantity: number
    modelReleaseDate: Timestamp
    name: Localized<string>
    features?: { id: Uuid<"Feature">; text: Localized<string> }[]
    shortDescription?: Localized<string>
    description?: Localized<Markdown>
    monthlyPrice: PhoneOrderPriceMonthlyCost
    monthlyPrices: { rentalPeriod: number; price: PhoneOrderPriceMonthlyCost }[]
    images?: Image[]
    rentalPeriodTotalPrice: CurrencyAmount
    rentalPeriod: number
    insurance?: Uuid<"Insurance">
    relativePhysicalSize?: RelativePhysicalSize
    tradeInDiscount?: TradeInDiscount
}
export type ShippingType = "Manual" | "PostalShipping"
export type TradeInPriceRequest = {
    form: Uuid<"TradeInDeviceForm">
    version: number
    responses: Uuid<"TradeInResponse">[]
}
export type PhoneOrderPriceRequest = {
    phone: PhoneOffer
    shippingType?: ShippingType
    shippingSlot?: Uuid<"ManualShippingSlot">
    tradeIn?: TradeInPriceRequest
    /** If omitted, the user's default address will be used.*/
    shippingAddress?: Address
}
export type PhoneOrderPrice = {
    phoneOffer: PhoneOffer
    monthlyCost: PhoneOrderPriceMonthlyCost
    shippingCost: CurrencyAmount
    rentalPeriodTotalPrice: CurrencyAmount
}
/** Validates, checks availability and calculates the price of a phone order. */
SSRHook.clientEndpoints.push({ name: "postPhoneOrderPrice", func: postPhoneOrderPrice })
export async function postPhoneOrderPrice(
    body: PhoneOrderPriceRequest,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PhoneOrderPrice> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-order/price`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Conflict = {
    /** The type of this error, can be used for union discrimination*/ type: "Conflict"
    status: number
    detail: string
    stack?: string
}
export type NoPhoneWithSpecifiedProperties = {
    /** The type of this error, can be used for union discrimination*/
    type: "NoPhoneWithSpecifiedProperties"
    status: number
    detail: string
    stack?: string
}
export type NotFound = {
    /** The type of this error, can be used for union discrimination*/ type: "NotFound"
    status: number
    detail: string
    stack?: string
}
export type BadTradeInResponse = {
    questionIndex: number
    response: Uuid<"TradeInResponse">
    /** The type of this error, can be used for union discrimination*/
    type: "BadTradeInResponse"
    status: number
    detail: string
    stack?: string
}
export type PostPhoneOrderPriceError =
    | BadRequest
    | Conflict
    | NoPhoneWithSpecifiedProperties
    | NotFound
    | BadTradeInResponse
export function IsPostPhoneOrderPriceError(e: any): e is PostPhoneOrderPriceError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" ||
            e.type === "Conflict" ||
            e.type === "NoPhoneWithSpecifiedProperties" ||
            e.type === "NotFound" ||
            e.type === "BadTradeInResponse")
    )
}
export const usePhoneOrderPrice = SSRHook<[body: PhoneOrderPriceRequest | null], PhoneOrderPrice>(
    "postPhoneOrderPrice",
    "PhoneOrderPrice",
    undefined,
    postPhoneOrderPrice,
    ["body"],
    undefined
)
export type PhoneOrderRequest =
    | (PhoneOrderPriceRequest & {
          termsAndConditions: Uuid<"TermsAndConditions">
          insuranceTermsAndConditions: Uuid<"TermsAndConditions">
      } & { shippingType: "Manual"; shippingSlot: Uuid<"ManualShippingSlot"> })
    | (PhoneOrderPriceRequest & {
          termsAndConditions: Uuid<"TermsAndConditions">
          insuranceTermsAndConditions: Uuid<"TermsAndConditions">
      } & { shippingType: ShippingType })
export type PostPhoneOrderDto = { id: Uuid<"PhoneOrder">; status: string }
/** Places a phone order for the current user. This implies consent to the terms
and conditions. */
SSRHook.clientEndpoints.push({ name: "postPhoneOrder", func: postPhoneOrder })
export async function postPhoneOrder(
    body: PhoneOrderRequest,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostPhoneOrderDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-order`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Unauthorized = {
    /** The type of this error, can be used for union discrimination*/ type: "Unauthorized"
    status: number
    detail: string
    stack?: string
}
export type JWTPropertyMissing = {
    /** The property name that was required in the JWT payload.*/ propName: string
    /** The expected type of the property*/
    expectedType?: string
    /** The type of this error, can be used for union discrimination*/
    type: "JWTPropertyMissing"
    status: number
    detail: string
    stack?: string
}
export type PostPhoneOrderError =
    | Forbidden
    | BadRequest
    | UnauthorizedWithVipps
    | Conflict
    | NoPhoneWithSpecifiedProperties
    | NotFound
    | BadTradeInResponse
    | Unauthorized
    | JWTPropertyMissing
export function IsPostPhoneOrderError(e: any): e is PostPhoneOrderError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" ||
            e.type === "BadRequest" ||
            e.type === "UnauthorizedWithVipps" ||
            e.type === "Conflict" ||
            e.type === "NoPhoneWithSpecifiedProperties" ||
            e.type === "NotFound" ||
            e.type === "BadTradeInResponse" ||
            e.type === "Unauthorized" ||
            e.type === "JWTPropertyMissing")
    )
}
export type PostOrderTradeInRequestBodyDto = { tradeIn: TradeInPriceRequest }
SSRHook.clientEndpoints.push({ name: "postOrderTradeIn", func: postOrderTradeIn })
export async function postOrderTradeIn(
    id: Uuid<"PhoneOrder">,
    body: PostOrderTradeInRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-order/${id}/trade-in`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostOrderTradeInError = NotFound | BadRequest | BadTradeInResponse
export function IsPostOrderTradeInError(e: any): e is PostOrderTradeInError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "BadRequest" || e.type === "BadTradeInResponse")
    )
}
SSRHook.clientEndpoints.push({
    name: "postExpirePhoneReservationOrder",
    func: postExpirePhoneReservationOrder,
})
export async function postExpirePhoneReservationOrder(
    id: Uuid<"PhoneOrder">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (id !== undefined) queryArgs.push("id=" + encodeURIComponent(id.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/expire/phone/reservation/order${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostExpirePhoneReservationOrderError =
    | NotFound
    | BadRequest
    | Unauthorized
    | UnauthorizedWithVipps
export function IsPostExpirePhoneReservationOrderError(
    e: any
): e is PostExpirePhoneReservationOrderError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" ||
            e.type === "BadRequest" ||
            e.type === "Unauthorized" ||
            e.type === "UnauthorizedWithVipps")
    )
}
/** Returns offers for the phones available for sale.
Pass models argument to limit which models to get offers for. */
SSRHook.clientEndpoints.push({ name: "getPhoneOffers", func: getPhoneOffers })
export async function getPhoneOffers(
    models?: Uuid<"PhoneModel">[],
    sizes?: string[],
    colors?: string[],
    rentalPeriod?: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PhoneOffer[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (models !== undefined)
            queryArgs.push(...models.map((x) => "models=" + encodeURIComponent(x.valueOf())))
        if (sizes !== undefined)
            queryArgs.push(...sizes.map((x) => "sizes=" + encodeURIComponent(x.valueOf())))
        if (colors !== undefined)
            queryArgs.push(...colors.map((x) => "colors=" + encodeURIComponent(x.valueOf())))
        if (rentalPeriod !== undefined)
            queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/phone-offers${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetPhoneOffersError = BadRequest
export function IsGetPhoneOffersError(e: any): e is GetPhoneOffersError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const usePhoneOffers = SSRHook<
    [
        models: Uuid<"PhoneModel">[] | null | undefined,
        sizes: string[] | null | undefined,
        colors: string[] | null | undefined,
        rentalPeriod: number | null | undefined,
    ],
    PhoneOffer[]
>(
    "getPhoneOffers",
    undefined,
    undefined,
    getPhoneOffers,
    ["models", "sizes", "colors", "rentalPeriod"],
    undefined
)
export type Color = string & string
export type ProductColor = {
    /** The name of the color. This is the value that will be stored in the database.*/ name: string
    displayName: Localized<string>
    /** A part of a phones stock keeping unit (SKU) id*/
    skuName?: string
    color: Color
}
SSRHook.clientEndpoints.push({ name: "getPhoneColors", func: getPhoneColors })
export async function getPhoneColors(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<ProductColor[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-colors`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const usePhoneColors = SSRHook<[], ProductColor[]>(
    "getPhoneColors",
    undefined,
    undefined,
    getPhoneColors,
    [],
    undefined
)
export type StorageSize = {
    /** The name of the storage size. This is the value that will be stored in the database.*/
    name: string
    displayName: string
    /** A part of a phones stock keeping unit (SKU) id*/
    skuName?: string
    /** The amount of storage in gigabytes.*/
    size: number
}
SSRHook.clientEndpoints.push({ name: "getPhoneStorageSizes", func: getPhoneStorageSizes })
export async function getPhoneStorageSizes(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<StorageSize[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-storage-sizes`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const usePhoneStorageSizes = SSRHook<[], StorageSize[]>(
    "getPhoneStorageSizes",
    undefined,
    undefined,
    getPhoneStorageSizes,
    [],
    undefined
)
export type GetPhonesPriceHistogramDto = { bars: number[]; min: number; max: number }
SSRHook.clientEndpoints.push({ name: "getPhonesPriceHistogram", func: getPhonesPriceHistogram })
export async function getPhonesPriceHistogram(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPhonesPriceHistogramDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-price-histogram`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PhoneModelSoldOut = {
    /** The type of this error, can be used for union discrimination*/ type: "PhoneModelSoldOut"
    status: number
    detail: string
    stack?: string
}
export type GetPhonesPriceHistogramError = NotFound | PhoneModelSoldOut | BadRequest
export function IsGetPhonesPriceHistogramError(e: any): e is GetPhonesPriceHistogramError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "PhoneModelSoldOut" || e.type === "BadRequest")
    )
}
export const usePhonesPriceHistogram = SSRHook<[], GetPhonesPriceHistogramDto>(
    "getPhonesPriceHistogram",
    "GetPhonesPriceHistogramDto",
    undefined,
    getPhonesPriceHistogram,
    [],
    undefined
)
export type GetPhoneOfferOptionsColorsDto = {
    /** The name of the color. This is the value that will be stored in the database.*/ name: string
    color: Color
    displayName: Localized<string>
    inStock: boolean
    storageSizes: string[]
}
export type GetPhoneOfferOptionsStorageSizesDto = {
    /** The name of the storage size. This is the value that will be stored in the database.*/
    name: string
    /** The amount of storage in gigabytes.*/
    size: number
    displayName: Localized<string>
    inStock: boolean
    colors: string[]
}
export type GetPhoneOfferOptionsRentalPeriodsDto = {
    /** The name of the period in months.*/ months: number
    displayName: Localized<string>
}
export type GetPhoneOfferOptionsDto = {
    colors: GetPhoneOfferOptionsColorsDto[]
    storageSizes: GetPhoneOfferOptionsStorageSizesDto[]
    rentalPeriods: GetPhoneOfferOptionsRentalPeriodsDto[]
}
export type GetPhoneOfferDto = { offer: PhoneOffer; options: GetPhoneOfferOptionsDto }
/** Returns a particular phone offer, including the available model specific configuration
options. */
SSRHook.clientEndpoints.push({ name: "getPhoneOffer", func: getPhoneOffer })
export async function getPhoneOffer(
    id: Uuid<"Phone">,
    rentalPeriod?: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPhoneOfferDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (rentalPeriod !== undefined)
            queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/phone-offers/${id}${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetPhoneOfferError = NotFound | PhoneModelSoldOut | BadRequest
export function IsGetPhoneOfferError(e: any): e is GetPhoneOfferError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NotFound" || e.type === "PhoneModelSoldOut" || e.type === "BadRequest")
    )
}
export const usePhoneOffer = SSRHook<
    [id: Uuid<"Phone"> | null, rentalPeriod: number | null | undefined],
    GetPhoneOfferDto
>("getPhoneOffer", "GetPhoneOfferDto", undefined, getPhoneOffer, ["id", "rentalPeriod"], undefined)
/** Requests an updated phone offer after a user has modified it, e.g. selected a
different color or storage size. */
SSRHook.clientEndpoints.push({ name: "postPhoneOffer", func: postPhoneOffer })
export async function postPhoneOffer(
    prop: "color" | "rentalPeriod" | "storage" | "insurance",
    body: PhoneOffer,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PhoneOffer> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (prop !== undefined) queryArgs.push("prop=" + encodeURIComponent(prop.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/phone-offers${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostPhoneOfferError = NoPhoneWithSpecifiedProperties | NotFound | BadRequest
export function IsPostPhoneOfferError(e: any): e is PostPhoneOfferError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "NoPhoneWithSpecifiedProperties" ||
            e.type === "NotFound" ||
            e.type === "BadRequest")
    )
}
export type GetPhoneModelFeatures1Dto = { id: Uuid<"Feature">; text: Localized<string> }
export type GetPhoneModelColorsDto = {
    /** The name of the color. This is the value that will be stored in the database.*/ name: string
    color: Color
    displayName: Localized<string>
}
export type GetPhoneModelRentalPeriodsDto = {
    /** The name of the period in months.*/ months: number
    displayName: Localized<string>
}
export type GetPhoneModelInsurancesDto = { id: Uuid<"Insurance">; version: number }
export type GetPhoneModelDto = {
    id: Uuid<"PhoneModel">
    name: Localized<string>
    /** Features for this phone to be promoted in the product cards and on the product page.*/
    features: undefined | GetPhoneModelFeatures1Dto[]
    /** A more detailed description of the phone model.*/
    description: undefined | Localized<Markdown>
    /** When listing the model next to other models, like the front page, the phone size should
be reduced to this size (relative to full size which is 100 %).*/
    relativePhysicalSize: undefined | RelativePhysicalSize
    images: Url[]
    colors: GetPhoneModelColorsDto[]
    storageSizes: StorageSize[]
    rentalPeriods: GetPhoneModelRentalPeriodsDto[]
    insurances: GetPhoneModelInsurancesDto[]
}
/** Returns information about a phone model, including the different attributes
and their possible values. */
SSRHook.clientEndpoints.push({ name: "getPhoneModel", func: getPhoneModel })
export async function getPhoneModel(
    modelId: Uuid<"PhoneModel">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPhoneModelDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-models/${modelId}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const usePhoneModel = SSRHook<[modelId: Uuid<"PhoneModel"> | null], GetPhoneModelDto>(
    "getPhoneModel",
    "GetPhoneModelDto",
    undefined,
    getPhoneModel,
    ["modelId"],
    undefined
)
export type GetPhoneModelsFeatures1Dto = { id: Uuid<"Feature">; text: Localized<string> }
export type GetPhoneModelsColorsDto = {
    /** The name of the color. This is the value that will be stored in the database.*/ name: string
    color: Color
    displayName: Localized<string>
}
export type GetPhoneModelsRentalPeriodsDto = {
    /** The name of the period in months.*/ months: number
    displayName: Localized<string>
}
export type GetPhoneModelsInsurancesDto = { id: Uuid<"Insurance">; version: number }
export type GetPhoneModelsDto = {
    id: Uuid<"PhoneModel">
    name: Localized<string>
    /** Features for this phone to be promoted in the product cards and on the product page.*/
    features: undefined | GetPhoneModelsFeatures1Dto[]
    /** A more detailed description of the phone model.*/
    description: undefined | Localized<Markdown>
    /** When listing the model next to other models, like the front page, the phone size should
be reduced to this size (relative to full size which is 100 %).*/
    relativePhysicalSize: undefined | RelativePhysicalSize
    images: Image[]
    colors: GetPhoneModelsColorsDto[]
    storageSizes: StorageSize[]
    rentalPeriods: GetPhoneModelsRentalPeriodsDto[]
    insurances: GetPhoneModelsInsurancesDto[]
}
SSRHook.clientEndpoints.push({ name: "getPhoneModels", func: getPhoneModels })
export async function getPhoneModels(
    modelIds: Uuid<"PhoneModel">[],
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetPhoneModelsDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (modelIds !== undefined)
            queryArgs.push(...modelIds.map((x) => "modelIds=" + encodeURIComponent(x.valueOf())))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/phone-models${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const usePhoneModels = SSRHook<[modelIds: Uuid<"PhoneModel">[] | null], GetPhoneModelsDto[]>(
    "getPhoneModels",
    undefined,
    undefined,
    getPhoneModels,
    ["modelIds"],
    undefined
)
export type GetCountriesDto = { code: CountryCode; name: string; flag: string }
SSRHook.clientEndpoints.push({ name: "getCountries", func: getCountries })
export async function getCountries(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetCountriesDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/countries`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useCountries = SSRHook<[], GetCountriesDto[]>(
    "getCountries",
    undefined,
    undefined,
    getCountries,
    [],
    undefined
)
export type Grade = {
    id: Uuid<"Grade">
    name: Localized<string>
    /** A part of a phones stock keeping unit (SKU) id*/
    skuName?: string
    /** A description of what this grade means for the customer.*/
    description: Localized<Markdown>
}
SSRHook.clientEndpoints.push({ name: "getConditionGrades", func: getConditionGrades })
export async function getConditionGrades(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<Grade[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/condition/grades`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useConditionGrades = SSRHook<[], Grade[]>(
    "getConditionGrades",
    undefined,
    undefined,
    getConditionGrades,
    [],
    undefined
)
export type TradeInDeviceType = "Phones"
export type GetTradeInFormQuestionsResponsesDto = {
    id: Uuid<"TradeInResponse">
    image: undefined | Image
    response: Localized<string>
}
export type GetTradeInFormQuestionsDto = {
    id: Uuid<"TradeInQuestion">
    /** The question.*/
    question: Localized<string>
    /** An extra field that can be used for further explaination of the question.*/
    description: undefined | Localized<string>
    type: "buttons" | "dropdown"
    responses: GetTradeInFormQuestionsResponsesDto[]
}
export type GetTradeInFormDto = {
    id: Uuid<"TradeInDeviceForm">
    /** An image to present in the trade in flow. Can be overridden per answer.*/
    image: undefined | Image
    version: number
    questions: GetTradeInFormQuestionsDto[]
}
SSRHook.clientEndpoints.push({ name: "getTradeInForm", func: getTradeInForm })
export async function getTradeInForm(
    type: TradeInDeviceType,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetTradeInFormDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/trade-in-forms/${type}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useTradeInForm = SSRHook<[type: TradeInDeviceType | null], GetTradeInFormDto>(
    "getTradeInForm",
    "GetTradeInFormDto",
    undefined,
    getTradeInForm,
    ["type"],
    undefined
)
export type PostTradeInFormsValueRequestBodyDto = {
    responses: Uuid<"TradeInResponse">[]
    months: number
}
export type PostTradeInFormsValueDto = {
    monthlyDiscount: CurrencyAmount
    months: number
    deviceName: undefined | Localized<string>
    value: CurrencyAmount
    /** Whether the trade-in form is complete. If false, the value is just
the temporary value based on the questions answered so far.*/
    isComplete: boolean
}
/** Computes the value of your trade-in device. */
SSRHook.clientEndpoints.push({ name: "postTradeInFormsValue", func: postTradeInFormsValue })
export async function postTradeInFormsValue(
    type: TradeInDeviceType,
    body: PostTradeInFormsValueRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<PostTradeInFormsValueDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/trade-in-forms/${type}/value`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostTradeInFormsValueError = BadTradeInResponse | BadRequest
export function IsPostTradeInFormsValueError(e: any): e is PostTradeInFormsValueError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadTradeInResponse" || e.type === "BadRequest")
    )
}
export type GetInsuranceOptionsSellingPointsDto = {
    id: Uuid<"Uuid">
    text: Localized<string>
    /** Override the icon that should be used when presenting this selling point in an
icon list.*/
    icon?: IconName
}
export type GetInsuranceOptionsTermsAndConditionsDto = {
    id: Uuid<"TermsAndConditions">
    content: Localized<Markdown>
}
export type GetInsuranceOptionsDto = {
    id: Uuid<"Insurance">
    displayName: Localized<string>
    description: Localized<string>
    sellingPoints: GetInsuranceOptionsSellingPointsDto[]
    termsAndConditions: GetInsuranceOptionsTermsAndConditionsDto
    pricePerMonth: undefined | number
}
SSRHook.clientEndpoints.push({ name: "getInsuranceOptions", func: getInsuranceOptions })
export async function getInsuranceOptions(
    model: Uuid<"PhoneModel">,
    storageSize: string,
    color: string,
    rentalPeriod: number,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetInsuranceOptionsDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (model !== undefined) queryArgs.push("model=" + encodeURIComponent(model.valueOf()))
        if (storageSize !== undefined)
            queryArgs.push("storageSize=" + encodeURIComponent(storageSize.valueOf()))
        if (color !== undefined) queryArgs.push("color=" + encodeURIComponent(color.valueOf()))
        if (rentalPeriod !== undefined)
            queryArgs.push("rentalPeriod=" + encodeURIComponent(rentalPeriod.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/insurance-options${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetInsuranceOptionsError = BadRequest
export function IsGetInsuranceOptionsError(e: any): e is GetInsuranceOptionsError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const useInsuranceOptions = SSRHook<
    [
        model: Uuid<"PhoneModel"> | null,
        storageSize: string | null,
        color: string | null,
        rentalPeriod: number | null,
    ],
    GetInsuranceOptionsDto[]
>(
    "getInsuranceOptions",
    undefined,
    undefined,
    getInsuranceOptions,
    ["model", "storageSize", "color", "rentalPeriod"],
    undefined
)
export type GetMeDto = {
    anonymous: boolean
    canSkipLoginInCheckout: boolean
    id: undefined | Uuid<"User">
    email: undefined | Email
    givenName: undefined | string
    familyName: undefined | string
    address: undefined | Address
    phoneNumber: undefined | PhoneNumber
    createdAt: undefined | number
    disabledPaymentMethods: undefined | string[]
    orderLimitReached: undefined | boolean
    marketingConsent: boolean
    preferredStoredPaymentMethodId: undefined | string
}
SSRHook.clientEndpoints.push({ name: "getMe", func: getMe })
export async function getMe(customHeaders?: Headers, callOptions?: CallOptions): Promise<GetMeDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch((callOptions?.baseUrl ?? defaults.baseUrl) + `/api/me`, {
            method: "get",
            headers,
        })
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useMe = SSRHook<[], GetMeDto>("getMe", "GetMeDto", undefined, getMe, [], undefined)
export type GetStoredPaymentMethodsDto = {
    /** A unique identifier of this stored payment method.*/ id: undefined | string
    /** The type of payment method.*/
    type: undefined | string
    /** The brand of the card.*/
    brand: undefined | string
    /** The month the card expires.*/
    expiryMonth: undefined | string
    /** The last two digits of the year the card expires. For example, **22** for the year 2022.*/
    expiryYear: undefined | string
    /** The last four digits of the PAN.*/
    lastFour: undefined | string
}
SSRHook.clientEndpoints.push({ name: "getStoredPaymentMethods", func: getStoredPaymentMethods })
export async function getStoredPaymentMethods(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetStoredPaymentMethodsDto[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/me/payment-methods`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type InternalServerError = {
    /** The type of this error, can be used for union discrimination*/ type: "InternalServerError"
    status: number
    detail: string
    stack?: string
}
export type GetStoredPaymentMethodsError = InternalServerError | UnauthorizedWithVipps
export function IsGetStoredPaymentMethodsError(e: any): e is GetStoredPaymentMethodsError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "InternalServerError" || e.type === "UnauthorizedWithVipps")
    )
}
export const useStoredPaymentMethods = SSRHook<[], GetStoredPaymentMethodsDto[]>(
    "getStoredPaymentMethods",
    undefined,
    undefined,
    getStoredPaymentMethods,
    [],
    undefined
)
export type PutMarketingConsentRequestBodyDto = { consent: boolean }
SSRHook.clientEndpoints.push({ name: "putMarketingConsent", func: putMarketingConsent })
export async function putMarketingConsent(
    body: PutMarketingConsentRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/me/marketing-consent`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PutMarketingConsentError = UnauthorizedWithVipps
export function IsPutMarketingConsentError(e: any): e is PutMarketingConsentError {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps"
}
export type PutPreferredStoredPaymentMethodRequestBodyDto = { storedPaymentMethodId: string }
SSRHook.clientEndpoints.push({
    name: "putPreferredStoredPaymentMethod",
    func: putPreferredStoredPaymentMethod,
})
export async function putPreferredStoredPaymentMethod(
    body: PutPreferredStoredPaymentMethodRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/me/preferred-stored-payment-method`,
            {
                method: "put",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PutPreferredStoredPaymentMethodError = UnauthorizedWithVipps
export function IsPutPreferredStoredPaymentMethodError(
    e: any
): e is PutPreferredStoredPaymentMethodError {
    return e && typeof e === "object" && "type" in e && e.type === "UnauthorizedWithVipps"
}
export type Question = {
    id: Uuid<"Question">
    question: Localized<string>
    /** The answer to the question.*/
    answer: Localized<Markdown>
}
export type FrequentlyAskedQuestions = { questions: Question[] }
SSRHook.clientEndpoints.push({
    name: "getFrequentlyAskedQuestions",
    func: getFrequentlyAskedQuestions,
})
export async function getFrequentlyAskedQuestions(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<FrequentlyAskedQuestions> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/frequently/asked/questions`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useFrequentlyAskedQuestions = SSRHook<[], FrequentlyAskedQuestions>(
    "getFrequentlyAskedQuestions",
    "FrequentlyAskedQuestions",
    undefined,
    getFrequentlyAskedQuestions,
    [],
    undefined
)
export type NewsletterUnsubscribePage = {
    heading: Localized<string>
    text: Localized<Markdown>
    buttonText: Localized<string>
    successMessage: Localized<Markdown>
    errorMessage: Localized<Markdown>
    missingParameterMessage: Localized<Markdown>
}
SSRHook.clientEndpoints.push({
    name: "getNewsletterUnsubscribePage",
    func: getNewsletterUnsubscribePage,
})
export async function getNewsletterUnsubscribePage(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<NewsletterUnsubscribePage> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/newsletter/unsubscribe-page`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useNewsletterUnsubscribePage = SSRHook<[], NewsletterUnsubscribePage>(
    "getNewsletterUnsubscribePage",
    "NewsletterUnsubscribePage",
    undefined,
    getNewsletterUnsubscribePage,
    [],
    undefined
)
export type PostNewsletterUnsubscribeRequestBodyDto = { id: Uuid<"WaitingListSignup"> }
SSRHook.clientEndpoints.push({ name: "postNewsletterUnsubscribe", func: postNewsletterUnsubscribe })
export async function postNewsletterUnsubscribe(
    body: PostNewsletterUnsubscribeRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/newsletter/unsubscribe`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Rating = number
export type Review = {
    id: Uuid<"Review">
    rating: Rating
    name: Localized<string>
    title: Localized<string>
    text: Localized<string>
    timestamp: Timestamp
}
export type Reviews = { reviews: Review[] }
SSRHook.clientEndpoints.push({ name: "getReviews", func: getReviews })
export async function getReviews(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<Reviews> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/reviews`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useReviews = SSRHook<[], Reviews>(
    "getReviews",
    "Reviews",
    undefined,
    getReviews,
    [],
    undefined
)
export type MoreReasonsToRedoitCard = {
    id: Uuid<"HowItWorksCard">
    /** The text that is shown on the bottom of the card until it is opened.*/
    heading: Localized<string>
    /** The text with more information that is shown when the card is opened.*/
    text: Localized<Markdown>
    /** Image for the card.*/
    image?: Image
}
export type MoreReasonsToRedoit = {
    /** Section heading.*/ heading: Localized<string>
    cards: MoreReasonsToRedoitCard[]
    /** Short string that is prefixed before the title to generate a read more.*/
    readMoreAriaPrefix: Localized<string>
}
SSRHook.clientEndpoints.push({ name: "getMoreReasonsToRedoit", func: getMoreReasonsToRedoit })
export async function getMoreReasonsToRedoit(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<MoreReasonsToRedoit> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/more/reasons/to/redoit`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useMoreReasonsToRedoit = SSRHook<[], MoreReasonsToRedoit>(
    "getMoreReasonsToRedoit",
    "MoreReasonsToRedoit",
    undefined,
    getMoreReasonsToRedoit,
    [],
    undefined
)
SSRHook.clientEndpoints.push({ name: "getNotificationsClosed", func: getNotificationsClosed })
export async function getNotificationsClosed(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<string[]> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/notifications/closed`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useNotificationsClosed = SSRHook<[], string[]>(
    "getNotificationsClosed",
    undefined,
    undefined,
    getNotificationsClosed,
    [],
    undefined
)
export type PostNotificationsClosedRequestBodyDto = { id: string }
SSRHook.clientEndpoints.push({ name: "postNotificationsClosed", func: postNotificationsClosed })
export async function postNotificationsClosed(
    body: PostNotificationsClosedRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/notifications/closed`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetHeaderItemsDto = {
    slug: undefined | Localized<string>
    id: Uuid<"WebMenuItem">
    /** Text for the menu item.*/
    text: Localized<string>
    /** The page to link to.*/
    page?: Uuid<"WebPage">
    /** A section to link to within the page selected above.*/
    section?: Uuid
    /** URL to link to if the menu item should link to an external page.*/
    url?: Url
    /** Show an icon next to the button text.*/
    icon?: IconName
}
export type GetHeaderTrustpilotDto = {
    /** The score to present on the Trustpilot button. Purely for demo purposes until
integration is ready.*/
    score: number
    /** The text to show on the Trustpilot button.*/
    text: Localized<string>
    /** The page the user will be taken to if clicking the Trustpilot button.*/
    url?: Url
}
export type GetHeaderLoginDto = { text: Localized<string>; url: Url }
export type GetHeaderAccountDto = {
    icon: IconName
    /** The text to show in the button. Available variables are `givenName` and `familyName`.*/
    text: Localized<string>
    /** The page the account profile button should link to when logged in.*/
    page: Uuid<"WebPage">
}
export type GetHeaderDto = {
    items: GetHeaderItemsDto[]
    /** The Trustpilot button to show in the navigation bar*/
    trustpilot?: GetHeaderTrustpilotDto
    /** The login button in the navigation bar.*/
    login?: GetHeaderLoginDto
    /** The account button in the navigation bar.*/
    account?: GetHeaderAccountDto
}
SSRHook.clientEndpoints.push({ name: "getHeader", func: getHeader })
export async function getHeader(
    pageId?: Uuid<"WebPage">,
    sectionId?: Uuid<"Section">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetHeaderDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (pageId !== undefined) queryArgs.push("pageId=" + encodeURIComponent(pageId.valueOf()))
        if (sectionId !== undefined)
            queryArgs.push("sectionId=" + encodeURIComponent(sectionId.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/header${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useHeader = SSRHook<
    [pageId: Uuid<"WebPage"> | null | undefined, sectionId: Uuid<"Section"> | null | undefined],
    GetHeaderDto
>("getHeader", "GetHeaderDto", undefined, getHeader, ["pageId", "sectionId"], undefined)
export type GetFooterItemsDto = {
    slug: undefined | Localized<string>
    id: Uuid<"WebFooterItem">
    /** Text for the menu item.*/
    text: Localized<string>
    /** The page to link to.*/
    page?: Uuid<"WebPage">
    /** A section to link to within the page selected above.*/
    section?: Uuid
    /** URL to link to if the menu item should link to an external page.*/
    url?: Url
}
export type GetFooterDto = { items: GetFooterItemsDto[] }
SSRHook.clientEndpoints.push({ name: "getFooter", func: getFooter })
export async function getFooter(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetFooterDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/footer`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useFooter = SSRHook<[], GetFooterDto>(
    "getFooter",
    "GetFooterDto",
    undefined,
    getFooter,
    [],
    undefined
)
export type GetCancellationTermsDto = {
    monthsRemaining: number
    cancellationFee: CurrencyAmount
    cancellationTerms: Localized<Markdown>
}
SSRHook.clientEndpoints.push({ name: "getCancellationTerms", func: getCancellationTerms })
export async function getCancellationTerms(
    id: Uuid<"PhoneOrder">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetCancellationTermsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/phone-orders/${id}/cancellation-terms`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetCancellationTermsError = BadRequest
export function IsGetCancellationTermsError(e: any): e is GetCancellationTermsError {
    return e && typeof e === "object" && "type" in e && e.type === "BadRequest"
}
export const useCancellationTerms = SSRHook<
    [id: Uuid<"PhoneOrder"> | null],
    GetCancellationTermsDto
>(
    "getCancellationTerms",
    "GetCancellationTermsDto",
    undefined,
    getCancellationTerms,
    ["id"],
    undefined
)
export type CancelSubscriptionRequestBodyDto = {
    cancellationFee: CurrencyAmount
    cancellationTerms: Localized<Markdown>
}
SSRHook.clientEndpoints.push({ name: "cancelSubscription", func: cancelSubscription })
export async function cancelSubscription(
    id: Uuid<"PhoneOrder">,
    body: CancelSubscriptionRequestBodyDto,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/phone-orders/${id}`,
            {
                method: "delete",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type CancelSubscriptionError = Forbidden | BadRequest | UnauthorizedWithVipps
export function IsCancelSubscriptionError(e: any): e is CancelSubscriptionError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "Forbidden" || e.type === "BadRequest" || e.type === "UnauthorizedWithVipps")
    )
}
export type GetGeneralPhoneOrderTermsAndConditionsPhoneOrderDto = {
    id: Uuid<"TermsAndConditions">
    content: Localized<Markdown>
}
export type GetGeneralPhoneOrderTermsAndConditionsInsuranceDto = {
    id: Uuid<"TermsAndConditions">
    content: Localized<Markdown>
}
export type GetGeneralPhoneOrderTermsAndConditionsDto = {
    phoneOrder: GetGeneralPhoneOrderTermsAndConditionsPhoneOrderDto
    insurance: GetGeneralPhoneOrderTermsAndConditionsInsuranceDto
}
/** Previews the terms and conditions for a phone order. */
SSRHook.clientEndpoints.push({
    name: "getGeneralPhoneOrderTermsAndConditions",
    func: getGeneralPhoneOrderTermsAndConditions,
})
export async function getGeneralPhoneOrderTermsAndConditions(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<GetGeneralPhoneOrderTermsAndConditionsDto> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/terms-and-conditions/phone-order`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useGeneralPhoneOrderTermsAndConditions = SSRHook<
    [],
    GetGeneralPhoneOrderTermsAndConditionsDto
>(
    "getGeneralPhoneOrderTermsAndConditions",
    "GetGeneralPhoneOrderTermsAndConditionsDto",
    undefined,
    getGeneralPhoneOrderTermsAndConditions,
    [],
    undefined
)
SSRHook.clientEndpoints.push({ name: "getTermsAndConditions", func: getTermsAndConditions })
export async function getTermsAndConditions(
    id: Uuid<"TermsAndConditions">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<Localized<Markdown>> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/terms-and-conditions/${id}`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.json()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export const useTermsAndConditions = SSRHook<
    [id: Uuid<"TermsAndConditions"> | null],
    Localized<Markdown>
>("getTermsAndConditions", "Localized", undefined, getTermsAndConditions, ["id"], undefined)
SSRHook.clientEndpoints.push({
    name: "getWellKnownAppleDeveloperMerchantidDomainAssociation",
    func: getWellKnownAppleDeveloperMerchantidDomainAssociation,
})
export async function getWellKnownAppleDeveloperMerchantidDomainAssociation(
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<string> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/well/known/apple/developer/merchantid/domain/association`,
            {
                method: "get",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return await _res.text()
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type GetWellKnownAppleDeveloperMerchantidDomainAssociationError = NotFound
export function IsGetWellKnownAppleDeveloperMerchantidDomainAssociationError(
    e: any
): e is GetWellKnownAppleDeveloperMerchantidDomainAssociationError {
    return e && typeof e === "object" && "type" in e && e.type === "NotFound"
}
export const useWellKnownAppleDeveloperMerchantidDomainAssociation = SSRHook<[], string>(
    "getWellKnownAppleDeveloperMerchantidDomainAssociation",
    undefined,
    undefined,
    getWellKnownAppleDeveloperMerchantidDomainAssociation,
    [],
    undefined
)
SSRHook.clientEndpoints.push({ name: "postWaitingListModalOpen", func: postWaitingListModalOpen })
export async function postWaitingListModalOpen(
    source?: string,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const queryArgs: string[] = []
        if (source !== undefined) queryArgs.push("source=" + encodeURIComponent(source.valueOf()))

        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) +
                `/api/waiting-list/modal-open${queryArgs.length ? "?" + queryArgs.join("&") : ""}`,
            {
                method: "post",
                headers,
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type Omit<T0, T1> = {
    email: Email
    locale: LocaleKey
    rentalPeriod?: number
    phoneModel?: string
    newsletterConsent: boolean
}
export type WaitingListSignup = {
    id: Uuid<"WaitingListSignup">
    email: Email
    phoneModel?: string
    rentalPeriod?: number
    newsletterConsent: boolean
    welcomeEmailSent: boolean
    locale: LocaleKey
}
SSRHook.clientEndpoints.push({ name: "postWaitingListSignup", func: postWaitingListSignup })
export async function postWaitingListSignup(
    body: Omit<WaitingListSignup, "id" | "welcomeEmailSent">,
    customHeaders?: Headers,
    callOptions?: CallOptions
): Promise<void> {
    const { maxRetries = 1 } = callOptions || {}
    for (let i = 0; i <= maxRetries; i++) {
        const headers = { ...defaults.headers, ...customHeaders }

        const _res = await defaults.fetch(
            (callOptions?.baseUrl ?? defaults.baseUrl) + `/api/waiting-list/signup`,
            {
                method: "post",
                headers,
                body: JSON.stringify(body),
            }
        )
        if (_res.status >= 200 && _res.status <= 299) return
        else {
            const { retry } = await SSRHook.handleError(_res)
            if (retry) continue
            else break
        }
    }
    throw new Error("Unhandled failed request")
}
export type PostWaitingListSignupError = BadRequest | Unauthorized | JWTPropertyMissing
export function IsPostWaitingListSignupError(e: any): e is PostWaitingListSignupError {
    return (
        e &&
        typeof e === "object" &&
        "type" in e &&
        (e.type === "BadRequest" || e.type === "Unauthorized" || e.type === "JWTPropertyMissing")
    )
}
